import React, { FC, useState } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent, useIonViewWillEnter, IonInfiniteScroll, IonInfiniteScrollContent } from '@ionic/react'
import { MktEmpty, CouponItem, CouponDetail, Header } from '@cps'
import { memberMobx, memberCardMobx } from '@mobxStore'
import { find, each, keyBy } from '@dt/fe-utils/dist/lodash'
import { MemberApi, ActivityAPI } from 'api/index'
import { modalLayer, useHistoryNew } from '@utils'
import mktController from '@ctrls/mktController'
import { deepClone, format } from '@dt/fe-utils'
import './index.scss'

import noCouponImg from '@img/no-coupon.png'

interface IProps extends IPage, RouteComponentProps { }

const pageSize: number = 10

const CouponGetRecord: FC<IProps> = () => {
  const history = useHistoryNew()
  const [couponsList, setCouponsList] = useState<any[]>([])
  const [page, setPage] = useState<number>(1)
  const [canget, setCanget] = useState<boolean>(true)
  const [couponMap, setCouponMap] = useState<any>({})

  const goDetail = (data: any) => {
    modalLayer(CouponDetail, { type: 'get', couponInfo: data }, 'couponDetail')
  }

  const onScrollEnd = (ev: any) => {
    if (canget) {
      setTimeout(() => {
        getData(page + 1)
        ev.target.complete()
      }, 500)
    }
  }

  const getData = async (pageNum: number) => {
    setPage(pageNum)
    const para: any = {
      brandId: memberMobx.brandId,
      memberId: memberMobx.memberInfo.memberId,
      page: pageNum,
      limit: pageSize,
    }
    MemberApi.getAcquiredLogs(para).then(async (res: any) => {
      if (!res.error) {
        const showCoupons: any[] = []
        const activeIds: number[] = []
        const couponIds: number[] = []
        each(res.items, (item: any) => {
          const itemCoupons: any[] = []
          each(item.coupons, (child: any) => {
            for (let i = 0; i < child.couponCnt; i++) {
              if (!couponIds.includes(child.couponId)) {
                couponIds.push(child.couponId)
              }
              itemCoupons.push({
                couponId: child.couponId,
              })
            }
          })
          item.coupons = itemCoupons
          if (item.type === 'cardCouponPolicy') {
            const findCard: any = find([...memberCardMobx.allCardList, ...memberCardMobx.brandLevelCardList], (m: any) => m.cardId === item.outId)
            item.title = findCard ? findCard.cardName : i18n.t('pageName.card')
          } else if (item.type === 'memberCouponPolicy') {
            item.title = i18n.t('mkt.member.memberCouponPolicy')
          } else if (item.type === 'activityCoupon') {
            if (item.sendType === 'birthdayCoupon') {
              item.title = i18n.t('mkt.member.birthdayCoupon')
            } else {
              if (!activeIds.includes(parseInt(item.outId))) {
                activeIds.push(parseInt(item.outId))
              }
            }
          }
          showCoupons.push(item)
        })
        if (activeIds.length > 0) {
          const activeList = await ActivityAPI.getActiveList({ activityId: activeIds })
          if (!activeList.error) {
            const activeMap = keyBy(activeList, 'activityId')
            each(showCoupons, (item: any) => {
              const findActive: any = activeMap[parseInt(item.outId)]
              if (findActive) item.title = findActive.activityName
            })
          }
        }
        if (couponIds.length > 0) {
          ActivityAPI.getCouponsList({
            couponIds: couponIds
          }).then((res: any) => {
            if (!res.error) {
              setCouponMap({ ...couponMap, ...keyBy(res, 'couponId') })
            }
          })
        }
        setCouponsList(couponsList.concat(showCoupons))
        if (pageNum + 1 > Math.ceil(res.meta.totalPages)) {
          setCanget(false)
        } else {
          setCanget(true)
        }
      }
    })
  }

  useIonViewWillEnter(() => {
    Promise.all([memberCardMobx.getCardList(), memberCardMobx.getLevelCardList()]).then(() => {
      getData(page)
    })
  })

  return (
    <IonPage className='coupon-get-record-page'>
      <Header onBack={() => mktController.goBack(history)} title={i18n.t('mkt.coupon.couponGetRecord')}></Header>
      <IonContent className='page-content'>
        {couponsList.length === 0 && <MktEmpty img={noCouponImg} />}
        {
          couponsList.length > 0 &&
            <div className='card-list'>
              {
                couponsList.map((item: any, index: number) => {
                  return (
                    <div className='coupon-area' key={index}>
                      <div className='header'>
                        <div className='title'>{item.title}</div>
                        <div className='des'>{format.toDateTime(item.addTime)}</div>
                      </div>
                      <div className='coupon-list'>
                        {
                          item.coupons.map((coupon: any, cIndex: number) => {
                            const hasItem: any = couponMap[coupon.couponId]
                            return hasItem && (
                              <div className='coupon-block' key={`${cIndex}-${coupon.couponId}`}>
                                <CouponItem type='get' couponInfo={hasItem} onClick={goDetail}></CouponItem>
                              </div>
                            )
                          })
                        }
                      </div>
                    </div>
                  )
                })
              }
            </div>
        }
        {
          canget &&
            <IonInfiniteScroll threshold='100px' onIonInfinite={(ev) => onScrollEnd(ev)}>
              <IonInfiniteScrollContent
                loadingSpinner='bubbles'
                loadingText={i18n.t('order.loadmore')}
              >
              </IonInfiniteScrollContent>
            </IonInfiniteScroll>
        }
      </IonContent>
    </IonPage>
  )
}

export default observer(CouponGetRecord)
